// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jp_a bgu_a bgu_j bgu_q bgu_rp bgu_rq bgu_w"};